//
//
//
//
//
//
//
//
//

export default {
  name: 'AppMobileNavVariantMenuItem',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    isExternal() {
      return String(this.item.url).startsWith('https')
    }
  }
}
